import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a451ce60&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a451ce60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451ce60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a451ce60')) {
      api.createRecord('a451ce60', component.options)
    } else {
      api.reload('a451ce60', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a451ce60&scoped=true&", function () {
      api.rerender('a451ce60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/Voucher.vue"
export default component.exports